import Vue from 'vue'
import { DirectiveOptions} from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// @ts-ignore
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '@/assets/styles/index.scss' // global css
import App from './App.vue'
import store from './store/index.js'
import router from './router/index.js'
// eslint-disable-next-line no-unused-vars
// import * as press from './common/premission' // 自定义按钮指令
// Object.keys(press).forEach(key => {
//   Vue.directive(key, (press as { [key: string]: DirectiveOptions  })[key])
// })

import '@/assets/icons' // icon
import '@/permission'
import $api from '@/api' // permission control
Vue.prototype.$Api = $api

// 挂载elementUI
Vue.use(ElementUI, { locale, size: 'small' })

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
